import { Dropdown } from 'primereact/dropdown';
import React, { Component } from 'react';

export class FilterBox extends Component
{
   constructor(props) {
		super(props);
        //inputId
        //items [{label,value}]
        //label
        //small?
        //onChange(inputId,value)
    }
    onChange=(e)=>
    {
        if(this.props.onChange)
            this.props.onChange(this.props.inputId,e.target.value);
    }
    render()
	{
        var size="w-12rem";
        if(this.props.small)
            size="w-6rem";
		return(            
                    <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon text-primary bg-white p-1" style={{minWidth:'6em'}}>{this.props.label}</span>   
                        <Dropdown inputId={this.props.inputId} value={this.props.value} options={this.props.items} 
                        optionLabel="label" optionValue="value" className={size}
                        onChange={this.onChange}
                        ></Dropdown>
                    </div>
        );
	}
}
export default FilterBox;